export default "__VITE_ASSET__DQZEbUuP__"